let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e5s8b")).then(() => parcelRequire('wdWjn'));